import CartAPI from 'api/Cart';
import Settings from 'utils/Settings';

const LocaleController = class {
  static init = async () => {
    if (Settings.cartLocale !== Settings.currentLocale && !Settings.storefrontCartEnabled) {
      await CartAPI.setLocale(Settings.currentLocale);
    }
  };
};

export default LocaleController;
